// Services
import { logoutUser, getUserToken } from './auth';

// Get data (list of taxonomy items)
export function getListingData(props) {
  let filter = '';

  if (
    props.dependOnValue &&
    typeof props.dependOnValue === 'object' &&
    props.dependOnValue.length > 0
  ) {
    props.dependOnValue.forEach((dependOnValue) => {
      if (
        dependOnValue &&
        typeof dependOnValue === 'object' &&
        dependOnValue.value
      ) {
        filter += `/${dependOnValue.filter}/${dependOnValue.value}`;
      }
    });
  }

  const token = getUserToken();

  // Fetch
  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${props.endpoint}${filter}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
  )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        // Translate/transform server data
        if (data.data && data.data.length > 0) {
          data.data = props.getRows(data.data);
        }

        return data;
      }
    });
}

// Delete single data (taxonomy item)
export function deleteData(props) {
  // Fetch
  const token = getUserToken();

  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${props.endpoint}/${props.identifier}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
  )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      } else if(response.status === 409) {
        window.alert(`This item cannot be deleted because it affects other records in the system`);
        return;
      }

      if (response.ok) {
        return response.ok;
      } else {
        return response.json();
      }
    })
    .then((data) => {
      if (typeof data === 'boolean') {
        return data;
      } else {
        throw new Error(
          data.messages.reduce(
            (message, prevMessage) => `${prevMessage}, ${message}`
          )
        );
      }
    });
}

// Get single data (taxonomy item)
export function getDetailData(props) {
  // Fetch
  const token = getUserToken();
  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${props.endpoint}/byhash/${props.itemHash}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
  )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        return data;
      }
    });
}

// Save single data (taxonomy item)
export function saveData(props) {
  // convert the formData to a JS object.
  const token = getUserToken();
  let _fetchBody = {};
  for (var [key, value] of props.formData.entries()) {
    let val_ = '';

    // test if the value is a json string;
    try {
      val_ = JSON.parse(value);
    } catch (error) {
      val_ = value;
    }

    _fetchBody[key] = val_;
  }

  // set the fetch method to POST
  let _fetchMethod = 'POST';
  let _fetchEndpoint = props.endpoint;

  if (props.itemHash !== 'new') {
    // if we are not creating a new item
    // then append the itemHash to the request endpoint
    _fetchEndpoint += `/${props.itemHash}`;
    // and change the request method to POST
    _fetchMethod = 'PUT';
  }

  // Fetch
  return fetch(`${process.env.REACT_APP_API_SERVER}/api${_fetchEndpoint}`, {
    method: _fetchMethod,
    headers: {
      'Content-Type': 'application/json',
      'Authorization' : `${token.type} ${token.value}`
    },
    body: JSON.stringify(_fetchBody)
  })
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((data) => {
      if (!data) {
        throw new Error('Invalid return.');
      } else {
        return data;
      }
    });
}

// Get the version information for the item
export function getVersionData(props) {

  // Fetch
  const token = getUserToken();
  
  return fetch(
    `${process.env.REACT_APP_API_SERVER}/api${props.endpoint}/${props.itemId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `${token.type} ${token.value}`
      }
    }
    )
    .then((response) => {
      if (response.status === 401) {
        logoutUser();
        return;
      }

      return response.json();
    })
    .then((response) => {
      if (!response['data']) {
        throw new Error('Invalid return.');
      } else {
        return props.getRows(response['data']);
      }
    });

}